import React, { lazy, Suspense } from 'react';
import { useSelector } from 'react-redux';
import { Panel } from '@printdeal/ui-library';
import { selectors as authSelectors } from '../store/slices/authSlice';
// @ts-expect-error
import { selectors as customerSelectors } from '../store/slices/customerSlice';
import PersonalAdviceWidget from './widgets/PersonalAdvice';
import { RootState } from '../store';

const MyAccountWidget = lazy(() => import(/* webpackChunkName: "my-account-widget" */ './widgets/MyAccount'));

const Sidebar = () => {
  const isLoggedIn = useSelector((state: RootState) => authSelectors.isLoggedIn(state));
  const isAuthLoading = useSelector((state: RootState) => authSelectors.isAuthLoading(state));
  const isCompanyCustomer = useSelector((state: RootState) => customerSelectors.isCustomerCompany(state));
  return (
    <Panel id="side-bar">
      {isLoggedIn && !isAuthLoading && (
        <>
          <Suspense fallback={null}>
            <MyAccountWidget />
          </Suspense>
          <hr className="pd-my-6" />
        </>
      )}
      <PersonalAdviceWidget
        isLoggedIn={isLoggedIn && !isAuthLoading}
        isCompanyCustomer={isCompanyCustomer}
      />
    </Panel>
  );
};

export default Sidebar;
